export const ACTIONVIEW_ALL_USER = "all";
export const ACTIONVIEW_DEPARTMENT_USER = "departmentUser";
export const ACTIONVIEW_BIRTHDAY_USER = "birthdayUser";
export const ACTIONVIEW_JOINMONTH_USER = "joinMonthUser";

export const ACTIONVIEW_ORGCHART_TITLE = "★★★組織図★★★"
export const ACTIONVIEW_BIRTHDAY_TITLE = "★★★今月の誕生日★★★"
export const ACTIONVIEW_JOINMONTH_TITLE = "★★★今月の新入社員★★★"

export const REQUEST_METHOD_GET = "GET";
export const REQUEST_METHOD_POST = "POST";

export const DIR_PATH_AWS = "/usr/share/nginx/html/profile/";
export const DIR_PATH_LOCAL = "C:/Users/haru9/OneDrive/Desktop/git/InternalTools/AllMemberView/Front/public/profile/";

export const DELETE_DEPARTMENT_NAME = "事業部";